import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { NombreToken } from '../../core/nombres-token';
import { Icono, NombreIcono } from '../icono/icono';

/**
 * Modal centrado con icono, título y una acción de cierre. Portado de
 * `ModalComponent` del backoffice (`src/components/modal/`), adaptado a signals.
 *
 * Lo monta y lo desmonta quien lo usa (`@if (abierto()) { <app-modal …> }`), como
 * el lightbox del video de la ficha; el backoffice además le pasa un `[open]`,
 * que acá sería el mismo dato dos veces. Cierra con la X, con un clic en el fondo
 * y con Escape.
 *
 * Se deja afuera del backoffice: la acción primaria con gradiente (el aviso de
 * contacto sólo tiene "Cerrar" — sumarla es una entrada más y su estilo), las
 * variantes de ancho/alto y de título, el par de iconos de `buttonsContact` y el
 * bloqueo del scroll de fondo (`ScrollLockService`), que el portal no tiene: el
 * modal aparece sobre pantallas cortas y ninguna queda a medio scrollear.
 */
@Component({
  selector: 'app-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Icono],
  templateUrl: './modal.html',
  styleUrl: './modal.scss',
  host: {
    // Escape cierra sin depender de dónde quedó el foco.
    '(document:keydown.escape)': 'cerrar.emit()',
  },
})
export class Modal {
  /** Glifo del círculo de arriba. Sin él, el modal arranca en el título. */
  readonly icono = input<NombreIcono>();
  readonly colorIcono = input<NombreToken>('c-communication-succeed_50');
  readonly fondoIcono = input<NombreToken>('c-communication-succeed_400');

  readonly titulo = input('');
  readonly descripcion = input('');

  /** Etiqueta del botón de cierre. Sin ella, sólo quedan la X y el fondo. */
  readonly etiquetaSecundaria = input('');

  readonly accionSecundaria = output<void>();
  readonly cerrar = output<void>();

  /* Los colores llegan como nombre de token para que el tipo generado los
     valide; el icono hereda el suyo con `currentColor`. */
  protected readonly colorIconoCss = computed(
    () => `var(--${this.colorIcono()})`,
  );
  protected readonly fondoIconoCss = computed(
    () => `var(--${this.fondoIcono()})`,
  );
}
